import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EntityConfigService } from "../services/entity-config-service";

export function RLCatalogAvailsAssocSearch() {
    var directive: ng.IDirective = {
        bindToController: true,
        controller: RLCatalogAvailsAssocSearchController,
        controllerAs: "searchVM",
        scope: {
            charTypeID: "=charTypeId",
            childTemplateIDs: "=childTemplateIds",
            canCreate: "=",
            entitySelected: "&",
            templateSelected: "&",
            filterTemplates: "="
        },
        template: require("/assets/app/templates/catalog-avails-assoc-search.html")
    };
    return directive;
}

class RLCatalogAvailsAssocSearchController {

    static $inject = ["$scope", "$q", "entityService", "notifyService", "entityConfigService"];

    charTypeID: number;
    childTemplateIDs: number[];
    canCreate: boolean;

    searchKeywords: string;
    searchPage: number;
    searchTemplate: string;
    searchSortDir: number;
    searchSortField: string;
    searchTemplates: Models.IKeyValuePair<string, string>[];
    searchNumFound: number;
    searchPageCount: number;
    searchPageSize: number;
    searchInitialized: boolean;

    itemRows: Models.IEntitySearchDoc[];
    entitySelected: (context: { document: Models.IEntitySearchDoc }) => any;
    templateSelected: (context: { template: Models.ICharacteristicTemplate }) => any;

    filterTemplates: Models.ICharacteristicTemplate[];
    lockedRows: _.Dictionary<boolean>;

    constructor(private $scope: ng.IScope, private $q: ng.IQService, private entityService: EntityService, private notifyService: NotifyService, private entityConfigService: EntityConfigService) {
        this.searchKeywords = "";
        this.searchPage = 1;
        this.searchTemplate = null;
        this.searchSortDir = 1;
        this.searchSortField = "";
        this.itemRows = [];
        this.searchTemplates = [];
        this.searchNumFound = 0;
        this.searchPageCount = 0;
        this.searchPageSize = 10;
        this.searchInitialized = false;
        this.lockedRows = {};

        this.$scope.$watchGroup([() => this.charTypeID, this.searchTemplate, () => this.searchSortDir, () => this.searchSortField, () => this.searchPageSize],
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (this.searchPage == 1) {
                        this.Search();
                    } else {
                        this.searchPage = 1;
                    }
                }
            });

        this.$scope.$watch(() => this.searchPage,
            (newValue, oldValue) => {
                this.Search();
            });


        this.$scope.$watch(() => this.searchTemplate,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (this.searchPage == 1) {
                        this.Search();
                    } else {
                        this.searchPage = 1;
                    }
                }
            });
    }

    Search() {
        var request: Models.IEntitySearchRequest = {
            ct: this.charTypeID,
            k: this.searchKeywords,
            p: this.searchPage,
            r: this.searchPageSize,
            t: this.searchTemplate,
            sd: this.searchSortDir,
            sf: this.searchSortField,
            ftids: this.filterTemplates.map(t => t.templateID)
        };
        this.notifyService.startProgress();
        this.entityService.search(request)
            .then((results) => {
                var promises = [];
                var recordIDs = results.resultDocs.map(doc => doc.recordID);
                var promise = this.entityService.getEntityStatuses(this.charTypeID, recordIDs)
                    .then(result => {
                        this.lockedRows = {};
                        this.lockedRows = _.transform<Models.IEntityStatus, boolean>(result, function (acc, value, key) { (acc[key] = value.lockIndicator > 0 || value.activeIndicator == 0) }, {});
                    });
                promises.push(promise);

                this.$q.all(promises)
                    .then(() => {
                        this.itemRows = results.resultDocs;
                        this.searchTemplates = this.FormatFacets(results.templateFacets);
                        this.searchNumFound = results.numFound;
                        this.searchPageCount = results.pageCount;
                        this.searchInitialized = true;
                    });
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    FormatFacets(facets: Models.IKeyValuePair<string, number>[]): Models.IKeyValuePair<string, string>[] {
        return _(facets)
            .filter((kvp) => {
                var pair = kvp.key.split("|");
                if (pair.length == 2) {
                    return _.any(this.filterTemplates, template => template.templateID == _.parseInt(pair[1]));
                }
                return false;
            })
            .map<Models.IKeyValuePair<string, string>>(
            (kvp) => {

                var value = "";
                var pair = kvp.key.split("|");
                if (pair.length == 2) {
                    value = pair[0] + " (" + kvp.value + ")";
                }
                return { key: kvp.key, value: value, count: kvp.value };
            }).valueOf();
    }

    SelectRow(document: Models.IEntitySearchDoc) {
        this.entitySelected({ document: document });
    }

    SelectTemplate($event: ng.IAngularEvent, template: Models.ICharacteristicTemplate) {
        $event.preventDefault();
        this.templateSelected({ template: template });
    }
}
